import React from 'react';
import PropTypes from 'prop-types';

import '../styles/BulkActions.scss';

import ModalRoot from 'components/ModalRoot';

// Bulk action modals
import BulkAddTransaction from '../BulkActionModals/BulkAddTransaction';

const BulkActions = ({ children, ...props }) => (
  <React.Fragment>
    <ul className='bulk-actions action-buttons'>
      {React.Children.map(children, (child) => React.cloneElement(child, { ...props }))}
    </ul>
    <ModalRoot modals={{ BulkAddTransaction }} />
  </React.Fragment>
);

BulkActions.propTypes = {
  children: PropTypes.node
};

BulkActions.defaultProps = {
  children: []
};

export default BulkActions;
